import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Student from './Student';
import Lightbox from '../../partials/Lightbox';
import Icon from '../../partials/Icon';
import Moment from 'react-moment';
import 'moment/locale/sv';

export default class Project extends Component {
    state = {
        project: {
            id: '',
            title: '',
            pivot: {
                shares: '',
                share_price: '',
                group_share_cut: '',
                start_date: '',
                end_date: ''
            }
        },
        group: {
        	uuid: '',
            id: ''
        },
        transactions: [
            {
                id: '',
                payment_success: 0,
                shares: 0,
                user: {
                    first_name: ''
                }
            }
        ],
        errors: '',
        message: '',
        redirectToDashboard: false,
        lightbox: false,
        sold: 0,
        earned: 0
    };

    constructor(props) {
        super(props);

        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    componentDidMount() {
        // Hämta projektet
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.group_id+'/projects/'+this.props.match.params.project_id)
            .then(response => {
                this.setState({
                    group: response.data,
                    project: response.data.projects[0],
                    students: response.data.students,
                    transactions: response.data.transactions
                });

                // Räkna ut hur många som sålts
                if (response.data.transactions.length > 0) {
                    var finished = _.filter(response.data.transactions, ['payment_success', 1]);
                    if (finished.length > 0) {
                        var sold = _.sumBy(finished, 'shares');
                        var earned = sold*response.data.projects[0].pivot.group_share_cut;
                        earned = earned.toString().replace(/./g, function(c, i, a) {
                            return i && c !== "." && ((a.length - i) % 3 === 0) ? ' ' + c : c;
                        });
                        this.setState({ sold });
                        this.setState({ earned });
                    }
                }
            });
    }

    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }

    render() {
        const { group, project, students, transactions } = this.state;
        const self = this;
        const API_WEB_URL = API_URL.endsWith('/api') ? API_URL.replace(new RegExp('/api$'), '') : API_URL;

        return (
            <div>
                <Lightbox open={ this.state.lightbox } toggle={ this.toggleLightbox } contents={ <div><h3>Projekt</h3><p>Här finner du all information du behöver för att hålla koll på er försäljning.</p><hr /><h3>Deltagare</h3><p>I listan kan du se varje deltagarens enskilda mål och försäljning. Klicka på en deltagarens namn för att se dennes transaktioner.</p><hr /><h3>Transaktioner</h3><p>Se de senaste transaktionerna.</p></div> } />

                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                        <button className="lightbox-toggle" onClick={ this.toggleLightbox }></button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>{ project.title }</h1>
                        <dl>
                            <dt>Sålda andelar</dt>
                                <dd>{ this.state.sold } / { project.pivot.shares } st</dd>
                            <dt>Intjänat</dt>
                                <dd>{ this.state.earned } kr</dd>
                            <dt>Styckpris</dt>
                                <dd>{ project.pivot.share_price } kr</dd>
                            <dt>Startdatum</dt>
                                <dd>{ project.pivot.start_date }</dd>
                            <dt>Slutdatum</dt>
                                <dd>{ project.pivot.end_date }</dd>
                        </dl>

						<div className="block">
							<div className="header">
								<h4>Dela i sociala medier</h4>
							</div>
							<div className="body">
								<a href={`${ API_WEB_URL }/grupp/${ group.uuid }/${ project.id }`} target="_blank" rel="noopener noreferrer">{ API_WEB_URL }/grupp/{ group.uuid }/{ project.id }</a>
							</div>
						</div>

                        <div className="block">
                            <div className="header">
                                <h4>Deltagare</h4>
                                <Link to={ `/admin/shares/${ group.id }/${ project.id }` }>Fördelning</Link>
                            </div>
                            <div className="body">
                                { students && students.length ? (
                                    <ul className="has-icons">
                                        { Object.keys(students).map(function(key) {
                                            return <Student key={ key } student={ students[key] } group_id={ self.props.match.params.group_id } project_id={ self.props.match.params.project_id } />
                                        }) }
                                    </ul>
                                ) : (
                                    <span>Det finns inga deltagare kopplade till detta projekt.</span>
                                ) }
                            </div>
                        </div>

                        <div className="block">
                            <div className="header">
                                <h4>Transaktioner</h4>
                            </div>
                            <div className="body">
                                { transactions && transactions.length > 0 ? (
                                    <ul className="has-icons compressed">
                                        { Object.keys(transactions).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    <Icon icon="transaction" color="pink" />

                                                    <span className="regular-text wrapper">
                                                        <span className="right small">
                                                            <Moment locale="sv" format="D/M">{ transactions[key].created_at }</Moment><br /> <Moment locale="sv" format="HH:mm">{ transactions[key].created_at }</Moment>
                                                        </span>
                                                        { transactions[key].user ? transactions[key].user.first_name : 'Webbplats' } &nbsp;
                                                        { transactions[key].payment_success === 0 ? (
                                                            <span>påbörjade försäljning av { transactions[key].shares }</span>
                                                        ) : (
                                                            <span>sålde { transactions[key].shares }</span>
                                                        ) }
                                                        { transactions[key].shares === 1 ? (
                                                            <span> andel</span>
                                                        ) : (
                                                            <span> andelar</span>
                                                        ) }
                                                    </span>
                                                </li>
                                            )
                                        }) }
                                    </ul>
                                ) : (
                                    <span>Det finns inga transaktioner.</span>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Project/index.js